import type { CityConfig } from "../city-template/types";

export const harrisonburgVaConfig: CityConfig = {
  city: "Harrisonburg",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "harrisonburg-va",
  route: "/cities/harrisonburg-va",
  title: "Emergency Passport Harrisonburg, VA | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Harrisonburg, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving the Shenandoah Valley, JMU, and the Blue Ridge region. Get your passport fast for study abroad and international travel!",
  h1: "Emergency & Expedited Passport Services in Harrisonburg, VA",
  heroSubtitle: "JMU study abroad deadline approaching? Passport expired before your trip? We help Harrisonburg and Shenandoah Valley travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Downtown%20Harrisonburg%20Virginia%20with%20the%20historic%20Court%20Square%20district%20and%20modern%20university%20buildings%20visible%20in%20the%20background%2C%20surrounded%20by%20the%20beautiful%20Blue%20Ridge%20Mountains%20and%20Shenandoah%20Valley%20landscape%2C%20warm%20golden%20hour%20lighting%2C%20professional%20photography%20with%20rich%20valley%20atmosphere%20and%20vibrant%20college%20town%20charm%2C%20no%20people%20visible%2C%20scenic%20urban%20landscape%20with%20rolling%20mountain%20backdrop%20and%20clear%20sky&width=1800&height=700&seq=harrisonburg-va-hero-001&orientation=landscape",
  heroImageAlt: "Downtown Harrisonburg Virginia with the Shenandoah Valley and Blue Ridge Mountains in the background",
  geoPosition: "38.4496;-78.8689",
  geoPlacename: "Harrisonburg, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 135 miles northeast of Harrisonburg via I-81",
  },
  nearbyCitiesZips: [
    { name: "Harrisonburg", zips: "22801, 22802, 22803, 22807" },
    { name: "Winchester", zips: "22601, 22602, 22603, 22604" },
    { name: "Staunton", zips: "24401, 24402" },
    { name: "Waynesboro", zips: "22980" },
    { name: "Charlottesville", zips: "22901, 22902, 22903, 22911, 22936, 22947, 22972, 22974" },
    { name: "Roanoke", zips: "24001, 24002, 24003, 24004, 24005, 24006, 24007, 24008, 24009, 24010, 24011, 24012, 24013, 24014, 24015, 24016, 24017, 24018, 24019, 24020, 24022, 24023, 24024, 24025, 24026, 24027, 24028, 24029, 24030, 24031, 24032, 24033, 24034, 24035, 24036, 24037, 24038, 24040, 24042, 24043, 24044, 24045, 24048, 24050, 24054, 24055, 24059, 24060, 24061, 24062, 24063, 24064, 24065, 24066, 24067, 24068, 24070, 24072, 24073, 24077, 24078, 24079, 24083, 24084, 24085, 24086, 24087, 24088, 24089, 24090, 24091, 24092, 24095" },
    { name: "Front Royal", zips: "22630" },
    { name: "Luray", zips: "22835" },
    { name: "Culpeper", zips: "22701" },
    { name: "Richmond", zips: "23218, 23219, 23220, 23221, 23222, 23223, 23224, 23225, 23226, 23227, 23228, 23229, 23230, 23231, 23233, 23234, 23235, 23236, 23237, 23238, 23242" },
    { name: "Fairfax", zips: "22030, 22031, 22032, 22033" },
    { name: "Arlington", zips: "22201, 22202, 22203, 22204, 22205, 22206, 22207, 22209, 22213, 22214, 22217" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent study abroad and travel departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Shenandoah Valley Hub", desc: "Serving Harrisonburg, JMU, Winchester, Staunton, and the Blue Ridge" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Charlottesville VA passport services", route: "/cities/charlottesville-va" },
    { name: "Roanoke VA passport services", route: "/cities/roanoke-va" },
    { name: "Winchester VA passport services", route: "/cities/winchester" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Harrisonburg remotely via secure courier. We do not have a walk-in office in Harrisonburg — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Harrisonburg and Shenandoah Valley travelers.",
  fpcOfficeAddress: "1629 K St NW #300, Washington, DC 20006",
  fpcOfficeDistance: "Serving all of Harrisonburg and the surrounding Shenandoah Valley including Winchester, Staunton, Waynesboro, Front Royal, Luray, and Culpeper",
  serviceAreaIntro: "From the bustling downtown of Harrisonburg's Court Square to the quiet neighborhoods of the Friendly City, from the James Madison University campus to the Eastern Mennonite University community, from the rolling farms of Rockingham County to the Shenandoah National Park entrance at Swift Run Gap — Fast Passport Center serves every corner of Harrisonburg and the Shenandoah Valley. We regularly help travelers from Winchester, Staunton, Waynesboro, Front Royal, and all across the valley get their passports fast.",
  nearbyCitiesIntro: "We serve all Harrisonburg neighborhoods and the surrounding Shenandoah Valley region including Winchester, Staunton, Waynesboro, Charlottesville, Roanoke, Front Royal, Luray, and Culpeper. If you are anywhere in the Harrisonburg area or the broader Shenandoah Valley and Blue Ridge region, we have you covered.",
  howItWorksIntro: "Most Harrisonburg travelers complete everything online and ship documents overnight. No need to drive to Washington, DC or wait in line at the regional agency.",
  mistakesIntro: "Harrisonburg travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Harrisonburg and Shenandoah Valley travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Harrisonburg? Here are the most common ones we hear from Shenandoah Valley travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  dmvWebsite: "https://www.dmv.virginia.gov",
  dmvLabel: "Virginia DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Harrisonburg international flights and study abroad departures.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Sarah M.",
      location: "Harrisonburg, VA",
      rating: 5,
      text: "I'm a JMU senior preparing for a study abroad semester in Barcelona. I realized my passport was expired just 3 weeks before departure. Fast Passport Center had my renewal in 4 days. I shipped from the UPS on South Main Street and it was the easiest thing ever. Every JMU student should know about this service!",
      service: "Passport Renewal",
    },
    {
      name: "Dr. Thomas R.",
      location: "Harrisonburg, VA",
      rating: 5,
      text: "As a professor at Eastern Mennonite University, I needed an emergency passport for a research trip to Geneva with 5 days notice. Fast Passport Center delivered in 3 days. Their understanding of academic travel schedules and the remote location of the Shenandoah Valley was incredibly helpful. I recommend them to all my colleagues.",
      service: "Emergency Passport",
    },
    {
      name: "Jennifer K.",
      location: "Winchester, VA",
      rating: 5,
      text: "First passports for my three kids before our family trip to Ireland. Fast Passport Center handled the parental consent requirements and had all three passports in 6 days. The convenience for Winchester residents was incredible — we shipped from the UPS on Jubal Early Drive and it was completely seamless. Shenandoah Valley families need this service.",
      service: "Child Passport",
    },
    {
      name: "Michael D.",
      location: "Staunton, VA",
      rating: 5,
      text: "Lost my passport 72 hours before a business trip to London. I was absolutely panicking because I live in Staunton and thought I would have to drive to DC. Fast Passport Center had a replacement in my hands in 48 hours. They saved my trip and my company was very impressed. Shenandoah Valley service is outstanding.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "harrisonburg-va-1",
      name: "Harrisonburg Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Harrisonburg",
      state: "VA",
      zip: "22801",
      phone: "(540) 434-8705",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Harrisonburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Harrisonburg facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "harrisonburg-va-2",
      name: "James Madison University (JMU) — Student Center",
      type: "USPS Passport Acceptance Facility",
      address: "Student Success Center, 738 S Mason St",
      city: "Harrisonburg",
      state: "VA",
      zip: "22807",
      phone: "(540) 568-6211",
      hours: "Mon–Fri: 10:00 AM – 3:00 PM",
      distance: "JMU campus, Harrisonburg",
      website: "https://www.jmu.edu",
      websiteLabel: "JMU Website",
      notes: "Convenient for JMU students and faculty. Passport services available on campus. Call to confirm appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "harrisonburg-va-3",
      name: "Winchester Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Winchester",
      state: "VA",
      zip: "22601",
      phone: "(540) 662-4432",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Winchester, north of Harrisonburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Winchester and Frederick County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "harrisonburg-va-4",
      name: "Staunton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Staunton",
      state: "VA",
      zip: "24401",
      phone: "(540) 885-4602",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Staunton, south of Harrisonburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Staunton and Augusta County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "harrisonburg-va-5",
      name: "Waynesboro Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Waynesboro",
      state: "VA",
      zip: "22980",
      phone: "(540) 943-8621",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Waynesboro, east of Harrisonburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Waynesboro and eastern Augusta County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "harrisonburg-va-6",
      name: "Rockingham County Clerk of Court",
      type: "County Clerk",
      address: "20 E Gay St",
      city: "Harrisonburg",
      state: "VA",
      zip: "22802",
      phone: "(540) 564-3000",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Harrisonburg, downtown area",
      website: "https://www.rockinghamcountyva.gov",
      websiteLabel: "Rockingham County Clerk",
      notes: "Provides birth certificate and vital records. Not a passport acceptance facility but useful for document collection.",
      icon: "ri-building-2-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — drive into downtown DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Harrisonburg photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Shenandoah Valley acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Harrisonburg applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Harrisonburg families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Harrisonburg travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Harrisonburg or nearby." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Harrisonburg address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Harrisonburg before my study abroad trip?", a: "Yes. Fast Passport Center provides emergency passport services in Harrisonburg for students and travelers with urgent international departures. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — perfect for JMU and EMU study abroad deadlines." },
    { q: "How fast can I renew my passport in Harrisonburg?", a: "Fast Passport Center offers fast passport renewal in Harrisonburg in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Harrisonburg?", a: "The nearest regional passport agency to Harrisonburg is the Washington Passport Agency, located approximately 135 miles away in downtown Washington, DC. For urgent processing without navigating the long drive through the Shenandoah Valley and I-81, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Harrisonburg without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Harrisonburg?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Harrisonburg residents." },
    { q: "Can I expedite a child passport in Harrisonburg?", a: "Yes. Fast Passport Center expedites child passports in Harrisonburg for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Harrisonburg families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Harrisonburg with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Harrisonburg?", a: "With Fast Passport Center's emergency courier service, Harrisonburg travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Harrisonburg?", a: "Popular options include the Harrisonburg Main Post Office (22801), James Madison University Student Center (22807), Winchester Post Office (22601), Staunton Post Office (24401), and Waynesboro Post Office (22980). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Harrisonburg?", a: "Same-day passports are only available at the Washington Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option — without the DC drive through the Shenandoah Valley." },
    { q: "What if I live in a smaller Shenandoah Valley town?", a: "We serve the entire Shenandoah Valley region including Winchester, Staunton, Waynesboro, Front Royal, Luray, Culpeper, and Charlottesville. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Harrisonburg?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
    { q: "Do you help with passport photos in Harrisonburg?", a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and FedEx Office locations in Harrisonburg, Winchester, and Staunton offer passport photo services. We review your photos before submission to ensure they meet State Department standards." },
    { q: "What documents do I need for a first-time passport in Harrisonburg?", a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk." },
    { q: "Can you help with a child's passport in Harrisonburg?", a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Harrisonburg families through the entire process and help schedule acceptance clerk appointments." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Harrisonburg", address: "1920 E Market St, Harrisonburg, VA 22801", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Harrisonburg", address: "2231 E Market St, Harrisonburg, VA 22801", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Harrisonburg", address: "1011 E Market St, Harrisonburg, VA 22801", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "CVS Pharmacy — Winchester", address: "1855 Senseny Rd, Winchester, VA 22601", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Winchester", address: "2850 Valley Ave, Winchester, VA 22601", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Staunton", address: "1022 Richmond Ave, Staunton, VA 24401", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Waynesboro", address: "1165 W Broad St, Waynesboro, VA 22980", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Charlottesville", address: "1025 Emmet St N, Charlottesville, VA 22903", hours: "Mon–Sun: 8AM–10PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Harrisonburg",
      address: "3280 Carrier Dr, Harrisonburg, VA 22801",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Staunton",
      address: "1180 N Augusta St, Staunton, VA 24401",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Winchester",
      address: "2350 S Pleasant Valley Rd, Winchester, VA 22601",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Winchester and Frederick County. REAL ID available.",
      featured: false,
    },
    {
      name: "Virginia DMV — Charlottesville",
      address: "1900 Seminole Trail, Charlottesville, VA 22901",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Charlottesville and eastern Shenandoah Valley. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "SHD",
      name: "Shenandoah Valley Regional Airport",
      distance: "Approximately 25 miles south of Harrisonburg near Staunton",
      address: "77 Aviation Circle, Weyers Cave, VA 24486",
      note: "The regional airport for Harrisonburg and the Shenandoah Valley. Direct flights to major hubs including Charlotte — perfect for connecting to international destinations. Accessible via I-81 and Route 256.",
      flightUrl: "https://www.flyshd.com/",
      flightLabel: "SHD Airport",
      featured: true,
    },
    {
      code: "CHO",
      name: "Charlottesville-Albemarle Airport",
      distance: "Approximately 50 miles southeast of Harrisonburg",
      address: "1000 Bowen Loop, Charlottesville, VA 22911",
      note: "Regional hub with flights to major domestic hubs including Atlanta, Charlotte, and New York. Accessible via I-81 and I-64.",
      flightUrl: "https://www.gocho.com/",
      flightLabel: "CHO Airport",
      featured: false,
    },
    {
      code: "DCA",
      name: "Ronald Reagan Washington National Airport",
      distance: "Approximately 135 miles northeast of Harrisonburg",
      address: "2401 Smith Ave, Arlington, VA 22202",
      note: "Major international hub for long-haul flights. Accessible via I-81 and I-66.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport",
      featured: false,
    },
    {
      code: "IAD",
      name: "Dulles International Airport",
      distance: "Approximately 120 miles northeast of Harrisonburg",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Major international hub for long-haul flights to Europe, Asia, and beyond. Accessible via I-81 and I-66.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Airport",
      featured: false,
    },
    {
      code: "ROA",
      name: "Roanoke-Blacksburg Regional Airport",
      distance: "Approximately 120 miles southwest of Harrisonburg",
      address: "5202 Aviation Dr NW, Roanoke, VA 24012",
      note: "Alternative regional hub for domestic flights. Accessible via I-81.",
      flightUrl: "https://www.flyroa.com/",
      flightLabel: "ROA Airport",
      featured: false,
    },
  ],
};